import { Controller } from "@hotwired/stimulus"

// Mobile drawer for the marketing-site top nav. Above md the drawer + toggle
// are display:none and this controller is dormant.
export default class extends Controller {
  static targets = ["toggle", "drawer", "scrim"]

  connect() {
    this._onKey = (e) => { if (e.key === "Escape") this.close() }
    document.addEventListener("keydown", this._onKey)
  }

  disconnect() {
    document.removeEventListener("keydown", this._onKey)
    document.body.style.overflow = ""
  }

  toggle() {
    this.element.dataset.open === "true" ? this.close() : this.open()
  }

  open() {
    this.element.dataset.open = "true"
    this.toggleTarget.setAttribute("aria-expanded", "true")
    this.toggleTarget.setAttribute("aria-label", "Close menu")
    this.drawerTarget.setAttribute("aria-hidden", "false")
    this.drawerTarget.removeAttribute("inert")
    document.body.style.overflow = "hidden"
    // Focus the first link so keyboard users land inside the drawer.
    const firstLink = this.drawerTarget.querySelector("a")
    if (firstLink) firstLink.focus({ preventScroll: true })
  }

  close() {
    this.element.dataset.open = "false"
    this.toggleTarget.setAttribute("aria-expanded", "false")
    this.toggleTarget.setAttribute("aria-label", "Open menu")
    this.drawerTarget.setAttribute("aria-hidden", "true")
    this.drawerTarget.setAttribute("inert", "")
    document.body.style.overflow = ""
  }
}
